export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7442.bf4b222a.jpg";